// Module
var code = "<employees-training user-uuid=\"{{employee.uuid}}\"></employees-training>\n";
// Exports
module.exports = code;